"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGrandTotal = exports.exportToPdf = exports.exportToXlsx = exports.exportSelectedToCsv = exports.exportToCsv = exports.buildCsvContent = exports.buildSelectedExportRows = exports.buildExportRows = exports.getExportColumns = exports.getPrimaryExportColumn = exports.sortTxns = exports.getTxnCategoryDisplay = exports.getTxnMemoForRow = exports.getTxnTagsValue = exports.getTagNames = exports.injectOtherBucket = exports.flattenNodesForView = exports.mapGroupRecordToNodes = exports.getTxnField = exports.getNextExpandedKeys = exports.csvEscape = exports.formatAmount = exports.toNumber = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const jspdf_1 = require("jspdf");
const jspdf_autotable_1 = require("jspdf-autotable");
const core_1 = require("components/QCurrency/core");
// ── Internal helpers ──
const isImmutableTag = (tag) => typeof (tag === null || tag === void 0 ? void 0 : tag.get) === 'function';
// eslint-disable-next-line @typescript-eslint/comma-dangle
const toArray = (value) => {
    if (!value) {
        return [];
    }
    if (typeof value.toArray === 'function') {
        return value.toArray();
    }
    return Array.isArray(value) ? value : [];
};
const getTagId = (tag) => {
    if (typeof tag === 'string' || typeof tag === 'number') {
        return tag;
    }
    return isImmutableTag(tag) ? tag.get('id') : tag.id;
};
const getTagName = (tag) => {
    if (typeof tag === 'string' || typeof tag === 'number') {
        return undefined;
    }
    return isImmutableTag(tag) ? tag.get('name') : tag.name;
};
const resolveTagName = (tag, tagsById) => {
    var _a, _b, _c, _d, _e, _f;
    if (!tag) {
        return null;
    }
    const name = getTagName(tag);
    if (name) {
        return name;
    }
    const id = getTagId(tag);
    return id != null ? ((_f = (_c = (_b = (_a = tagsById === null || tagsById === void 0 ? void 0 : tagsById.get) === null || _a === void 0 ? void 0 : _a.call(tagsById, String(id))) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_e = (_d = tagsById === null || tagsById === void 0 ? void 0 : tagsById.get) === null || _d === void 0 ? void 0 : _d.call(tagsById, id)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : null) : null;
};
// ── General utilities ──
const toNumber = (val) => {
    const num = typeof val === 'number' ? val : Number(val);
    return Number.isFinite(num) ? num : 0;
};
exports.toNumber = toNumber;
const formatAmount = (amount) => (0, core_1.formatAmount)((0, exports.toNumber)(amount), 'USD');
exports.formatAmount = formatAmount;
const csvEscape = (val) => {
    const escaped = val.replace(/"/g, '""');
    return /[",\n]/.test(val) ? `"${escaped}"` : escaped;
};
exports.csvEscape = csvEscape;
const getNextExpandedKeys = (prev, key, defaultExpanded = true) => { var _a; return (Object.assign(Object.assign({}, prev), { [key]: !((_a = prev[key]) !== null && _a !== void 0 ? _a : defaultExpanded) })); };
exports.getNextExpandedKeys = getNextExpandedKeys;
// eslint-disable-next-line @typescript-eslint/comma-dangle
const getTxnField = (txn, field) => typeof (txn === null || txn === void 0 ? void 0 : txn.get) === 'function'
    ? txn.get(field)
    : txn[field];
exports.getTxnField = getTxnField;
const OTHER_SUFFIX = '__other';
const getSplitItemForRow = (txn, categoryId, splitItemId) => {
    var _a, _b, _c, _d;
    if (categoryId == null && splitItemId == null) {
        return null;
    }
    // "Other <Category>" rows use a synthetic ID like "<realCategoryId>__other".
    // Strip the suffix so we can match the actual split item.
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    if (!splitItems) {
        return null;
    }
    const items = toArray(splitItems);
    if (items.length === 0) {
        return null;
    }
    if (splitItemId != null) {
        const resolvedSplitItemId = String(splitItemId);
        return (_c = items.find((item) => {
            const record = item;
            const id = typeof record.get === 'function' ? record.get('id') : item.id;
            const clientId = typeof record.get === 'function' ? record.get('clientId') : item.clientId;
            return (id != null && String(id) === resolvedSplitItemId) || (clientId != null && String(clientId) === resolvedSplitItemId);
        })) !== null && _c !== void 0 ? _c : null;
    }
    const idStr = String(categoryId);
    const resolvedId = idStr.endsWith(OTHER_SUFFIX)
        ? idStr.slice(0, idStr.length - OTHER_SUFFIX.length)
        : (categoryId !== null && categoryId !== void 0 ? categoryId : '');
    return (_d = items.find((item) => {
        const record = item;
        const coa = (typeof record.get === 'function' ? record.get('coa') : item === null || item === void 0 ? void 0 : item.coa);
        return (coa === null || coa === void 0 ? void 0 : coa.id) != null && (coa.id === resolvedId || String(coa.id) === String(resolvedId));
    })) !== null && _d !== void 0 ? _d : null;
};
// ── Grouping ──
const isUncategorized = (node) => { var _a; return ((_a = node.groupKey) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'uncategorized'; };
const sortGroupsAlphabetically = (nodes) => nodes.sort((leftNode, rightNode) => {
    if (isUncategorized(leftNode) !== isUncategorized(rightNode)) {
        return isUncategorized(leftNode) ? -1 : 1;
    }
    return (leftNode.groupKey || '').localeCompare(rightNode.groupKey || '', undefined, { sensitivity: 'base' });
});
const mapGroupRecordToNodes = (groupRecord) => {
    if (!groupRecord) {
        return [];
    }
    const nodes = Object.values(groupRecord).map((node) => (Object.assign(Object.assign({}, node), { subgroups: (0, exports.mapGroupRecordToNodes)(node.subgroups) })));
    return sortGroupsAlphabetically(nodes);
};
exports.mapGroupRecordToNodes = mapGroupRecordToNodes;
const flattenNodesForView = (nodes, maxDepth) => {
    const flattenedNodes = [];
    const walk = (items, depth) => {
        items.forEach((item) => {
            flattenedNodes.push(Object.assign(Object.assign({}, item), { depth }));
            const children = Array.isArray(item.subgroups) ? item.subgroups : [];
            if (children.length > 0 && depth < maxDepth) {
                walk(children, depth + 1);
            }
        });
    };
    walk(nodes, 0);
    return flattenedNodes;
};
exports.flattenNodesForView = flattenNodesForView;
const collectTxnIds = (nodes) => {
    const ids = new Set();
    nodes.forEach((node) => {
        var _a;
        (_a = node.txns) === null || _a === void 0 ? void 0 : _a.forEach((txn) => {
            const id = (0, exports.getTxnField)(txn, 'id');
            if (id) {
                ids.add(id);
            }
        });
    });
    return ids;
};
/**
 * Computes the corrected total and filtered transactions for an "Other" bucket.
 * Needed because duplicate children carry the parent's full total/txns,
 * but "Other" should only reflect txns not covered by real siblings.
 */
const buildOtherBucketData = (node, realChildren) => {
    const realChildTxnIds = collectTxnIds(realChildren);
    const txns = node.txns.filter((txn) => {
        const id = (0, exports.getTxnField)(txn, 'id');
        return !id || !realChildTxnIds.has(id);
    });
    const total = (node.total || 0) - realChildren.reduce((acc, c) => acc + (c.total || 0), 0);
    return { txns, total };
};
/** Renames duplicate-label children to "Other <Parent>" with corrected data. */
const injectOtherBucket = (nodes) => nodes.map((node) => {
    const children = Array.isArray(node.subgroups) ? node.subgroups : [];
    if (children.length === 0 || !node.txns || node.txns.size === 0) {
        return children.length > 0 ? Object.assign(Object.assign({}, node), { subgroups: (0, exports.injectOtherBucket)(children) }) : node;
    }
    const realChildren = children.filter((child) => child.groupKey !== node.groupKey);
    // All children are real (no duplicate) — recurse but don't inject
    if (realChildren.length === children.length) {
        return Object.assign(Object.assign({}, node), { subgroups: (0, exports.injectOtherBucket)(children) });
    }
    // Only duplicate child(ren), no real siblings — mark as leaf parent for Category Summary collapse
    if (realChildren.length === 0) {
        return Object.assign(Object.assign({}, node), { leafParent: true });
    }
    const other = buildOtherBucketData(node, realChildren);
    if (other.total === 0) {
        return Object.assign(Object.assign({}, node), { subgroups: (0, exports.injectOtherBucket)(children) });
    }
    // Rename duplicate children to "Other <Parent>" with corrected totals/txns.
    // Use child.txns (the duplicate child's own direct transactions) rather than
    // the filtered other.txns, because split transactions appear in both parent
    // and child nodes — filtering by child txn IDs would incorrectly empty the set.
    const updatedChildren = children.map((child) => {
        if (child.groupKey !== node.groupKey) {
            return child;
        }
        const otherKey = `Other ${node.groupKey}`;
        const otherId = node.categoryId ? `${node.categoryId}__other` : `other__${node.groupKey}`;
        return Object.assign(Object.assign({}, child), { groupKey: otherKey, categoryId: otherId, total: other.total, txns: child.txns, subgroups: [{ groupKey: otherKey, categoryId: otherId, total: other.total, txns: child.txns, subgroups: [] }] });
    });
    return Object.assign(Object.assign({}, node), { txns: undefined, subgroups: sortGroupsAlphabetically((0, exports.injectOtherBucket)(updatedChildren)) });
});
exports.injectOtherBucket = injectOtherBucket;
// ── Tags ──
const getTagNames = (tagsValue, tagsById) => toArray(tagsValue)
    .map((tag) => resolveTagName(tag, tagsById))
    .filter(Boolean)
    .join('/');
exports.getTagNames = getTagNames;
const getTxnTagsValue = (txn, categoryId, splitItemId) => {
    var _a, _b;
    const directTags = (0, exports.getTxnField)(txn, 'tags');
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    if (!splitItems) {
        return directTags;
    }
    // If this is a split transaction and we are rendering a specific split row,
    // never fall back to parent tags — Windows shows split-line tags only.
    if (splitItemId != null || categoryId != null) {
        const matched = getSplitItemForRow(txn, categoryId !== null && categoryId !== void 0 ? categoryId : null, splitItemId);
        if (matched) {
            const record = matched;
            return (typeof record.get === 'function' ? record.get('tags') : matched.tags);
        }
        return null;
    }
    // For payee-level rows (no category context) we intentionally *don't* aggregate tags
    // across split items. Windows Itemized Payees shows the parent transaction row with
    // a blank Tag column for split transactions unless the parent itself has tags.
    return directTags;
};
exports.getTxnTagsValue = getTxnTagsValue;
const getTxnMemoForRow = (txn, categoryId, splitItemId) => {
    var _a, _b;
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    if (!splitItems) {
        return (0, exports.getTxnField)(txn, 'memo') || '';
    }
    // Split transaction: if rendering a specific split row, show split memo only.
    if (categoryId != null || splitItemId != null) {
        const matched = getSplitItemForRow(txn, categoryId !== null && categoryId !== void 0 ? categoryId : null, splitItemId);
        if (!matched) {
            return '';
        }
        const record = matched;
        const splitMemo = (typeof record.get === 'function' ? record.get('memo') : matched.memo);
        return splitMemo || '';
    }
    // Otherwise (e.g., payee-level parent row), return parent memo.
    return (0, exports.getTxnField)(txn, 'memo') || '';
};
exports.getTxnMemoForRow = getTxnMemoForRow;
// ── Sorting ──
const getTxnNum = (txn) => {
    var _a, _b, _c, _d, _e, _f;
    return String((_f = (_d = (_c = (_b = (_a = (0, exports.getTxnField)(txn, 'checkNumber')) !== null && _a !== void 0 ? _a : (0, exports.getTxnField)(txn, 'checkNum')) !== null && _b !== void 0 ? _b : (0, exports.getTxnField)(txn, 'num')) !== null && _c !== void 0 ? _c : (0, exports.getTxnField)(txn, 'number')) !== null && _d !== void 0 ? _d : (_e = (0, exports.getTxnField)(txn, 'check')) === null || _e === void 0 ? void 0 : _e.number) !== null && _f !== void 0 ? _f : '').trim();
};
const getTxnCategoryDisplay = (txn, getCategoryName, categoryId, splitItemId) => {
    var _a, _b;
    const splitItems = (_b = ((_a = (0, exports.getTxnField)(txn, 'split')) !== null && _a !== void 0 ? _a : undefined)) === null || _b === void 0 ? void 0 : _b.items;
    let isSplit = false;
    if (splitItems) {
        isSplit = typeof splitItems.size === 'number'
            ? splitItems.size > 0
            : Array.isArray(splitItems) && splitItems.length > 0;
    }
    if (isSplit) {
        // When rendering a specific split detail row, resolve the split item's category.
        if (categoryId != null || splitItemId != null) {
            const matched = getSplitItemForRow(txn, categoryId !== null && categoryId !== void 0 ? categoryId : null, splitItemId);
            if (matched) {
                const record = matched;
                const coa = (typeof record.get === 'function' ? record.get('coa') : matched === null || matched === void 0 ? void 0 : matched.coa);
                if ((coa === null || coa === void 0 ? void 0 : coa.type) === 'UNCATEGORIZED') {
                    return 'Uncategorized';
                }
                return (getCategoryName === null || getCategoryName === void 0 ? void 0 : getCategoryName(coa === null || coa === void 0 ? void 0 : coa.id)) || '';
            }
        }
        return '--Split--';
    }
    const coa = (0, exports.getTxnField)(txn, 'coa');
    if ((coa === null || coa === void 0 ? void 0 : coa.type) === 'UNCATEGORIZED') {
        return 'Uncategorized';
    }
    return (getCategoryName === null || getCategoryName === void 0 ? void 0 : getCategoryName(coa === null || coa === void 0 ? void 0 : coa.id)) || '';
};
exports.getTxnCategoryDisplay = getTxnCategoryDisplay;
const getTxnSortValue = (txn, sortBy, tagsById, getAmount, getCategoryDisplay) => {
    switch (sortBy) {
        case 'date': {
            const millis = luxon_1.DateTime.fromISO((0, exports.getTxnField)(txn, 'postedOn') || '').toMillis();
            return Number.isFinite(millis) ? millis : 0;
        }
        case 'num': return getTxnNum(txn).toLowerCase();
        case 'payee': return ((0, exports.getTxnField)(txn, 'payee') || '').trim().toLowerCase();
        case 'category': return getCategoryDisplay ? getCategoryDisplay(txn).trim().toLowerCase() : '';
        case 'memo': return ((0, exports.getTxnField)(txn, 'memo') || '').trim().toLowerCase();
        case 'tag': return (0, exports.getTagNames)((0, exports.getTxnTagsValue)(txn), tagsById).trim().toLowerCase();
        case 'clr': return ((0, exports.getTxnField)(txn, 'state') || '').trim().toLowerCase();
        case 'amount': return getAmount ? getAmount(txn) : (0, exports.toNumber)((0, exports.getTxnField)(txn, 'amount'));
        default: return 0;
    }
};
const sortTxns = (txns, sortBy, sortDirection, tagsById, getAmount, getCategoryDisplay) => {
    const directionMultiplier = sortDirection === 'asc' ? 1 : -1;
    const sortedTransactions = txns.toArray().sort((leftTxn, rightTxn) => {
        const leftValue = getTxnSortValue(leftTxn, sortBy, tagsById, getAmount, getCategoryDisplay);
        const rightValue = getTxnSortValue(rightTxn, sortBy, tagsById, getAmount, getCategoryDisplay);
        if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return directionMultiplier * (leftValue - rightValue);
        }
        return directionMultiplier * String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true, sensitivity: 'base' });
    });
    return (0, immutable_1.List)(sortedTransactions);
};
exports.sortTxns = sortTxns;
// ── Export rows ──
const getPrimaryExportColumn = (breakdownBy) => breakdownBy === 'payee' ? 'Category' : 'Payee';
exports.getPrimaryExportColumn = getPrimaryExportColumn;
const getExportColumns = (breakdownBy) => [
    'Date',
    'Account',
    'Check #',
    (0, exports.getPrimaryExportColumn)(breakdownBy),
    'Memo',
    'Tag',
    'Clr',
    'Amount',
];
exports.getExportColumns = getExportColumns;
const mkExportRow = (row) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ({
        Date: (_a = row.Date) !== null && _a !== void 0 ? _a : '',
        Account: (_b = row.Account) !== null && _b !== void 0 ? _b : '',
        'Check #': (_c = row['Check #']) !== null && _c !== void 0 ? _c : '',
        Payee: (_d = row.Payee) !== null && _d !== void 0 ? _d : '',
        Category: (_e = row.Category) !== null && _e !== void 0 ? _e : '',
        Memo: (_f = row.Memo) !== null && _f !== void 0 ? _f : '',
        Tag: (_g = row.Tag) !== null && _g !== void 0 ? _g : '',
        Clr: (_h = row.Clr) !== null && _h !== void 0 ? _h : '',
        Amount: (_j = row.Amount) !== null && _j !== void 0 ? _j : '',
    });
};
const txnToExportRow = (txn, tagsById, getAccountString, formatAmountFn, breakdownBy, getCategoryName, getAmount, categoryId, splitItemId) => {
    const postedOn = (0, exports.getTxnField)(txn, 'postedOn');
    const primaryColumn = (0, exports.getPrimaryExportColumn)(breakdownBy);
    const primaryValue = breakdownBy === 'payee'
        ? (0, exports.getTxnCategoryDisplay)(txn, getCategoryName, categoryId, splitItemId)
        : ((0, exports.getTxnField)(txn, 'payee') || '');
    return mkExportRow({
        Date: postedOn ? luxon_1.DateTime.fromISO(postedOn).toFormat('MM/dd/yyyy') : '',
        Account: getAccountString((0, exports.getTxnField)(txn, 'accountId')),
        'Check #': getTxnNum(txn),
        [primaryColumn]: primaryValue,
        Memo: (0, exports.getTxnMemoForRow)(txn, categoryId, splitItemId),
        Tag: (0, exports.getTagNames)((0, exports.getTxnTagsValue)(txn, categoryId, splitItemId), tagsById),
        Clr: ((0, exports.getTxnField)(txn, 'state') || '').toString(),
        Amount: formatAmountFn(getAmount ? getAmount(txn) : (0, exports.toNumber)((0, exports.getTxnField)(txn, 'amount'))),
    });
};
const buildExportRows = (params) => {
    var _a, _b;
    const { breakdownBy, incomeRows, expenseRows, incomeReport, expenseReport, isTransactionsView, maxDepth, sortBy, sortDirection, tagsById, getTxnAmountForRow, getAccountString, getCategoryName, formatAmount: fmt, } = params;
    const rows = [];
    const addSection = (label, sectionRows) => {
        const sectionTotal = sectionRows
            .filter((row) => row.depth === 0)
            .reduce((total, row) => total + (row.total || 0), 0);
        rows.push(mkExportRow({ Date: label, Amount: fmt(sectionTotal) }));
        let prev = null;
        sectionRows.forEach((row) => {
            const hasChildren = Array.isArray(row.subgroups) && row.subgroups.length > 0;
            // Mirror the UI's hasVisibleChildren guard: only render txns at leaf rows
            const hasVisibleChildren = hasChildren && row.depth < maxDepth;
            const isDuplicate = prev && row.depth === prev.depth + 1 && row.groupKey === prev.groupKey;
            const addTxnRows = () => {
                if (isTransactionsView && row.txns && row.txns.size > 0) {
                    const splitItemIds = row === null || row === void 0 ? void 0 : row.splitItemIds;
                    const seenTxnIds = new Set();
                    (0, exports.sortTxns)(row.txns, sortBy, sortDirection, tagsById, (txn) => getTxnAmountForRow(txn, row))
                        .forEach((txn) => {
                        const txnId = (0, exports.getTxnField)(txn, 'id') || '';
                        if (seenTxnIds.has(txnId)) {
                            return;
                        }
                        seenTxnIds.add(txnId);
                        const txnSplitItemIds = splitItemIds === null || splitItemIds === void 0 ? void 0 : splitItemIds[txnId];
                        if (txnSplitItemIds && txnSplitItemIds.length > 0) {
                            txnSplitItemIds.forEach((splitItemId) => {
                                rows.push(txnToExportRow(txn, tagsById, getAccountString, fmt, breakdownBy, getCategoryName, (currentTxn) => getTxnAmountForRow(currentTxn, row, splitItemId), row.categoryId, splitItemId));
                            });
                        }
                        else {
                            rows.push(txnToExportRow(txn, tagsById, getAccountString, fmt, breakdownBy, getCategoryName, (currentTxn) => getTxnAmountForRow(currentTxn, row, null), row.categoryId, null));
                        }
                    });
                }
            };
            if (isDuplicate && !hasVisibleChildren) {
                addTxnRows();
                prev = { groupKey: row.groupKey, depth: row.depth };
                return;
            }
            rows.push(mkExportRow({ Date: `${'  '.repeat(row.depth)}${row.groupKey || ''}`, Amount: fmt(row.total || 0) }));
            if (!hasVisibleChildren) {
                addTxnRows();
            }
            prev = { groupKey: row.groupKey, depth: row.depth };
        });
    };
    addSection('INCOME', incomeRows);
    addSection('EXPENSES', expenseRows);
    rows.push(mkExportRow({
        Date: 'Overall Total',
        Amount: fmt((((_a = incomeReport === null || incomeReport === void 0 ? void 0 : incomeReport.get('rawReport')) === null || _a === void 0 ? void 0 : _a.get('total')) || 0) + (((_b = expenseReport === null || expenseReport === void 0 ? void 0 : expenseReport.get('rawReport')) === null || _b === void 0 ? void 0 : _b.get('total')) || 0)),
    }));
    return rows;
};
exports.buildExportRows = buildExportRows;
const buildSelectedExportRows = (params) => {
    const { breakdownBy, selectedTxns, sortBy, sortDirection, tagsById, getAccountString, getCategoryName, formatAmount: fmt, } = params;
    if (selectedTxns.size === 0) {
        return [];
    }
    return (0, exports.sortTxns)((0, immutable_1.List)(selectedTxns.toArray()), sortBy, sortDirection, tagsById)
        .toArray()
        .map((txn) => txnToExportRow(txn, tagsById, getAccountString, (value) => fmt((0, exports.toNumber)(value)), breakdownBy, getCategoryName));
};
exports.buildSelectedExportRows = buildSelectedExportRows;
const buildCsvContent = (rows, columns) => {
    const header = columns.join(',');
    const body = rows.map((row) => columns.map((column) => { var _a; return (0, exports.csvEscape)(((_a = row[column]) !== null && _a !== void 0 ? _a : '').toString()); }).join(',')).join('\n');
    return `${header}\n${body}\n`;
};
exports.buildCsvContent = buildCsvContent;
// ── File download ──
const downloadBlob = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 2000);
};
const makeFileName = (datasetName, suffix, ext) => `${datasetName || 'Dataset'}_ItemizedTransactions${suffix}_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.${ext}`;
const exportToCsv = (rows, datasetName, breakdownBy) => {
    downloadBlob(new Blob([(0, exports.buildCsvContent)(rows, (0, exports.getExportColumns)(breakdownBy))], { type: 'text/csv;charset=utf-8' }), makeFileName(datasetName, '', 'csv'));
};
exports.exportToCsv = exportToCsv;
const exportSelectedToCsv = (rows, datasetName, breakdownBy) => {
    if (rows.length === 0) {
        return;
    }
    downloadBlob(new Blob([(0, exports.buildCsvContent)(rows, (0, exports.getExportColumns)(breakdownBy))], { type: 'text/csv;charset=utf-8' }), makeFileName(datasetName, '_Selected', 'csv'));
};
exports.exportSelectedToCsv = exportSelectedToCsv;
const exportToXlsx = (rows, datasetName, breakdownBy) => __awaiter(void 0, void 0, void 0, function* () {
    const writeXlsxFile = (yield Promise.resolve().then(() => __importStar(require('write-excel-file')))).default;
    const schema = (0, exports.getExportColumns)(breakdownBy).map((column) => ({
        column,
        type: String,
        value: (val) => val[column],
        align: (column === 'Amount' ? 'right' : 'left'),
    }));
    yield writeXlsxFile(rows, { schema, fileName: makeFileName(datasetName, '', 'xlsx') });
});
exports.exportToXlsx = exportToXlsx;
const exportToPdf = (rows, datasetName, breakdownBy, dateRangeLabel, dateRange, filterObject, dataset) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const [{ getThemeByKey }, { generateFilterText }] = yield Promise.all([
        Promise.resolve().then(() => __importStar(require('themes/themeBase'))),
        Promise.resolve().then(() => __importStar(require('containers/NewReports/utils'))),
    ]);
    const theme = getThemeByKey('light');
    // eslint-disable-next-line new-cap
    const doc = new jspdf_1.jsPDF('l', 'pt', 'a4');
    const heading = `Itemized Transactions - ${dateRangeLabel}`;
    const rangeValue = dateRange === null || dateRange === void 0 ? void 0 : dateRange.value;
    const startDt = ((_a = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.start) === null || _a === void 0 ? void 0 : _a.isValid) ? rangeValue.start : null;
    const endDt = ((_b = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.end) === null || _b === void 0 ? void 0 : _b.isValid) ? rangeValue.end : null;
    const datePeriod = startDt && endDt
        ? `${startDt.toFormat('MM/dd/yyyy')} through ${endDt.toFormat('MM/dd/yyyy')}`
        : dateRangeLabel;
    const filterText = generateFilterText(filterObject);
    const exportColumns = (0, exports.getExportColumns)(breakdownBy);
    const primaryColumn = (0, exports.getPrimaryExportColumn)(breakdownBy);
    (0, jspdf_autotable_1.autoTable)(doc, {
        head: [exportColumns],
        body: rows,
        columns: exportColumns.map((col) => ({ header: col, dataKey: col })),
        styles: { fontSize: 10, overflow: 'linebreak', lineWidth: 0 },
        headStyles: {
            fillColor: false,
            textColor: theme.palette.text.strong,
            lineWidth: 0,
        },
        theme: 'plain',
        margin: { top: 105, left: 20, right: 20, bottom: 20 },
        columnStyles: {
            Date: { cellWidth: 180 },
            Account: { cellWidth: 115 },
            'Check #': { cellWidth: 70 },
            [primaryColumn]: { cellWidth: 115 },
            Memo: { cellWidth: 100 },
            Tag: { cellWidth: 85 },
            Clr: { cellWidth: 48 },
            Amount: { cellWidth: 87, halign: 'right' },
        },
        didParseCell: ({ row, cell, column }) => {
            var _a;
            if (row.section === 'head') {
                if (column.dataKey === 'Amount') {
                    // eslint-disable-next-line no-param-reassign
                    cell.styles.halign = 'right';
                }
                return;
            }
            if (row.section !== 'body') {
                return;
            }
            const raw = row.raw;
            const dateVal = (_a = raw.Date) === null || _a === void 0 ? void 0 : _a.trim();
            if (dateVal === 'INCOME' || dateVal === 'EXPENSES') {
                // eslint-disable-next-line no-param-reassign
                cell.styles.fillColor = theme.palette.tooltip.light;
                // eslint-disable-next-line no-param-reassign
                cell.styles.fontStyle = 'bold';
            }
            else if (dateVal === 'Overall Total') {
                // eslint-disable-next-line no-param-reassign
                cell.styles.fontStyle = 'bold';
            }
        },
        didDrawCell: ({ row, cell }) => {
            if (row.section === 'head') {
                doc.setDrawColor(theme.palette.text.strong);
                doc.setLineWidth(0.5);
                doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
            }
        },
        didDrawPage: () => {
            const xAxis = doc.internal.pageSize.width / 2;
            doc.setFontSize(14);
            doc.setTextColor(theme.palette.text.strong);
            doc.text(heading, xAxis, 40, { align: 'center' });
            doc.setFontSize(12);
            doc.text(datePeriod, xAxis, 60, { align: 'center', lineHeightFactor: 1 });
            doc.text(filterText, xAxis, 80, { align: 'center', lineHeightFactor: 1 });
        },
    });
    const pageCount = doc.getNumberOfPages();
    for (let pageNum = 1; pageNum <= pageCount; pageNum++) {
        doc.setPage(pageNum);
        doc.setFontSize(10);
        doc.setTextColor(theme.palette.icon.muted);
        doc.text(`Printed from ${(dataset === null || dataset === void 0 ? void 0 : dataset.name) || datasetName} on ${luxon_1.DateTime.now().toFormat('MM/dd/yyyy')}`, 20, doc.internal.pageSize.height - 15);
        doc.text(`Page ${pageNum}/${pageCount}`, doc.internal.pageSize.width - 70, doc.internal.pageSize.height - 15);
        doc.setTextColor(theme.palette.text.strong);
    }
    doc.save(makeFileName(datasetName, '', 'pdf'));
});
exports.exportToPdf = exportToPdf;
const sumTopLevelRowTotals = (rows) => rows.reduce((total, row) => total + (row.depth === 0 ? (0, exports.toNumber)(row.total) : 0), 0);
const getGrandTotal = (incomeRows, expenseRows) => sumTopLevelRowTotals(incomeRows) + sumTopLevelRowTotals(expenseRows);
exports.getGrandTotal = getGrandTotal;
